/*
* Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
* This file contains trade secrets of Honeywell International, Inc.
* No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell.
*/
import SettingsFieldComponentProps from "../../../models/componentModels/SettingsFieldComponentProps";
import TextBoxComponent from "./TextBoxComponent";
import { useState } from "react";
import TextAreaComponent from "./TextAreaComponent";
import SelectComponent from "./SelectComponent";
import ToggleComponent from "./ToggleComponent";

const SettingsFieldComponent = ({
  setting,
  newSettings,
  onInputChange,
  productId,
  TryThisSchema,
}: {
  setting: any;
  newSettings: any;
  onInputChange: any;
  productId: any;
  TryThisSchema: any;
}) => {
  const settingType: SettingsFieldComponentProps = setting?.type;

  let settingKeyValidation = ValidationCustomRegister(TryThisSchema);
  // useEffect(() => {
  //
  // }, [settingKeyValidation]);
  const normalizedSettingType =
    settingType === "bool" ? "boolean" : settingType;

  if (
    normalizedSettingType === "string" ||
    normalizedSettingType === "secret" ||
    normalizedSettingType === "number" ||
    normalizedSettingType === "textbox" ||
    normalizedSettingType === "url"
  ) {
    return (
      <TextBoxComponent
        setting={setting}
        newSettings={newSettings}
        onInputChange={onInputChange}
        productId={productId}
        schema={null}
        settingKeyValidation={settingKeyValidation}
      />
    );
  } else if (normalizedSettingType === "boolean") {
    return (
      <ToggleComponent
        setting={setting}
        newSettings={newSettings}
        onInputChange={onInputChange}
        productId={productId}
        settingKeyValidation={settingKeyValidation}
      />
    );
  } else if (normalizedSettingType === "json") {
    return (
      <TextAreaComponent
        setting={setting}
        newSettings={newSettings}
        onInputChange={onInputChange}
        productId={productId}
        settingKeyValidation={settingKeyValidation}
      />
    );
  } else if (normalizedSettingType === "select") {
    return (
      <SelectComponent
        setting={setting}
        newSettings={newSettings}
        onInputChange={onInputChange}
        productId={productId}
        settingKeyValidation={settingKeyValidation}
      />
    );
  } else return <></>;
};

export default SettingsFieldComponent;

//////////////get hook code here/////////////
export function ValidationCustomRegister(schema: any) {
  const [value, setValue] = useState<string | number>();
  const [error, setError] = useState(undefined);

  const handleChange = (e: { target: { value: any } }) => {
    let newValue = e?.target?.value;

    if (typeof newValue === "string") {
      const normalizedValue = newValue.trim();
      if (normalizedValue.toLowerCase() === "true") {
        newValue = "true";
      } else if (normalizedValue.toLowerCase() === "false") {
        newValue = "false";
      } else {
        try {
          if (+normalizedValue) {
            newValue = +normalizedValue;
            setValue(+normalizedValue);
          }
        } catch (error) {
          setValue(normalizedValue);
        }
      }
    }

    const result = (schema as any)?.safeParse(newValue);

    if (!result?.success) {
      const errorMessage = result?.error?.formErrors?.formErrors[0];
      setError(errorMessage);
      return errorMessage;
    } else {
      setError(undefined);
      return undefined;
    }
  };

  return {
    value,
    onChange: handleChange,
    error,
  };
}

//////////// end hook code here/////////////
